import { ApproveModalComponent } from './approve-modal/approve-modal.component';
import { ModalOverlayComponent } from './modal-overlay/modal-overlay.component';

export const Components = [
	ApproveModalComponent,
	ModalOverlayComponent,
];

export const EntryComponents = [
	ApproveModalComponent,
	ModalOverlayComponent,
];
